// extracted by mini-css-extract-plugin
export var black = "_g-6";
export var brand = "_g-1";
export var ddefault = "_g-0";
export var error = "_g-3";
export var gray = "_g-2";
export var highContrast = "_g-8";
export var outline = "_g-7";
export var success = "_g-5";
export var warning = "_g-4";